var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "context" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "show-close": false,
            "append-to-body": "",
            size: "70%",
            visible: _vm.cg,
            direction: "rtl",
            withHeader: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cg = $event
            },
          },
        },
        [
          _vm.detailObj
            ? _c("div", { staticClass: "drawerContext" }, [
                _c("div", { staticClass: "title" }, [
                  _c("i", {
                    staticClass: "el-icon-close",
                    staticStyle: { "margin-left": "10px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.cg = false
                      },
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("采购单详情"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "context" },
                  [
                    _vm._v(
                      " 创建时间：" +
                        _vm._s(_vm.$moment(_vm.detailObj.createdTime)) +
                        " "
                    ),
                    _c(
                      "el-table",
                      { attrs: { data: _vm.detailObj.itemVOs } },
                      [
                        _c("el-table-column", {
                          attrs: { label: "序号", type: "index", width: "55" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "创建时间", "min-width": "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm.$moment(scope.row.createdTime))
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            873524573
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "supplierName", label: "供应商" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "createdName", label: "创建人" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "purchaseOrgName", label: "采购部门" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "采购仓库" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.mapWarName(scope.row.depotVos)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4060318371
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ["商品", "赠品"][
                                            scope.row.purchaseProdType - 1
                                          ]
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2368827057
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdName",
                            label: "采购商品",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "采购图片" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "查看更多",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        scope.row.purchaseImage
                                          ? _c("el-image", {
                                              directives: [
                                                {
                                                  name: "image-preview",
                                                  rawName: "v-image-preview",
                                                },
                                              ],
                                              staticStyle: {
                                                width: "60px",
                                                height: "60px",
                                                cursor: "pointer",
                                              },
                                              attrs: {
                                                src:
                                                  _vm.ImgHttps +
                                                  scope.row.purchaseImage.split(
                                                    ","
                                                  )[0],
                                              },
                                              on: {
                                                click: function ($event) {
                                                  ;(_vm.imageSrc =
                                                    scope.row.purchaseImage),
                                                    (_vm.dialogVisible = true)
                                                },
                                              },
                                            })
                                          : _c("span", [_vm._v("/")]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1570924333
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdBrandName",
                            label: "采购品牌",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdQuantity",
                            label: "采购数量",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdSpecificationName",
                            label: "采购规格",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdPrice",
                            label: "采购单价",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdAmount",
                            label: "采购金额",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "show-close": false,
            "append-to-body": "",
            size: "70%",
            visible: _vm.cgrk,
            direction: "rtl",
            withHeader: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cgrk = $event
            },
          },
        },
        [
          _vm.detailObj
            ? _c("div", { staticClass: "drawerContext" }, [
                _c("div", { staticClass: "title" }, [
                  _c("i", {
                    staticClass: "el-icon-close",
                    staticStyle: { "margin-left": "10px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.cgrk = false
                      },
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("采购入库单详情"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "context" },
                  [
                    _vm._v(
                      " 创建时间：" +
                        _vm._s(_vm.$moment(_vm.detailObj.createdTime)) +
                        " "
                    ),
                    _c(
                      "el-table",
                      { attrs: { data: _vm.detailObj } },
                      [
                        _c("el-table-column", {
                          attrs: { label: "序号", type: "index", width: "55" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "supplierName", label: "供应商" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "createdName", label: "创建人" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "inDepotOrgName", label: "入库部门" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "入库仓库" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.mapWarName(
                                            scope.row
                                              .orderPurchaseInOrderProdDepotList
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            671927822
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ["商品", "赠品"][
                                            Number(scope.row.inDepotProdType) -
                                              1
                                          ]
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1887766549
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "inDepotProdName", label: "入库商品" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品图片" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "60px",
                                        height: "60px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        src:
                                          _vm.ImgHttps +
                                          scope.row.inDepotProdImage.split(
                                            ","
                                          )[0],
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;(_vm.imageSrc =
                                            scope.row.inDepotProdImage),
                                            (_vm.dialogVisible = true)
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3326240538
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "inDepotProdBrandName",
                            label: "入库品牌",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "inDepotProdQuantity",
                            label: "入库数量",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "inDepotProdSpecificationName",
                            label: "入库规格",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdPrice",
                            label: "入库单价",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchaseProdAmount",
                            label: "入库金额",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "show-close": false,
            "append-to-body": "",
            size: "70%",
            visible: _vm.cgth,
            direction: "rtl",
            withHeader: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cgth = $event
            },
          },
        },
        [
          _vm.detailObj
            ? _c("div", { staticClass: "drawerContext" }, [
                _c("div", { staticClass: "title" }, [
                  _c("i", {
                    staticClass: "el-icon-close",
                    staticStyle: { "margin-left": "10px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.cgth = false
                      },
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("退货详情"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "context" },
                  [
                    _c("p", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        " 创建时间：" +
                          _vm._s(_vm.$moment(_vm.detailObj.createdTime)) +
                          " "
                      ),
                    ]),
                    _c(
                      "el-table",
                      { attrs: { data: _vm.detailObj.items } },
                      [
                        _c("el-table-column", {
                          attrs: { label: "序号", type: "index", width: "55" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "supplierName", label: "供应商" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "createdName", label: "创建人" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "returnOrgName", label: "退货部门" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "退货仓库" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm._l(
                                    scope.row.depotVOS,
                                    function (items) {
                                      return _c("span", { key: items }, [
                                        _vm._v(_vm._s(items.returnDepotName)),
                                      ])
                                    }
                                  )
                                },
                              },
                            ],
                            null,
                            false,
                            2212500824
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ["商品", "赠品"][
                                            scope.row.returnProdType - 1
                                          ]
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1317975760
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "returnProdName", label: "退货商品" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品图片" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "60px",
                                        height: "60px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        src:
                                          _vm.ImgHttps +
                                          scope.row.returnProdImage,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3134514050
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "returnProdBrandName",
                            label: "退货品牌",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "returnProdQuantity",
                            label: "退货数量",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "returnProdSpecificationName",
                            label: "退货规格",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "returnProdPrice", label: "退货单价" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "returnProdAmount",
                            label: "退货金额",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "show-close": false,
            "append-to-body": "",
            size: "70%",
            visible: _vm.cghh,
            direction: "rtl",
            withHeader: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cghh = $event
            },
          },
        },
        [
          _vm.detailObj.orderPurchaseExchangeOrderBase
            ? _c("div", { staticClass: "drawerContext" }, [
                _c("div", { staticClass: "title" }, [
                  _c("i", {
                    staticClass: "el-icon-close",
                    staticStyle: { "margin-left": "10px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.cghh = false
                      },
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("采购换货详情"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "context" },
                  [
                    _vm._v(
                      " 创建时间：" +
                        _vm._s(
                          _vm.$moment(
                            _vm.detailObj.orderPurchaseExchangeOrderBase
                              .createdTime
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.detailObj.orderPurchaseExchangeOrderItem,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "序号", type: "index", width: "55" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "supplierName", label: "供应商" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "createdName", label: "创建人" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "exchangeOrgName", label: "采购部门" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "采购仓库" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.mapWarName(
                                            scope.row
                                              .orderPurchaseExchangeOrderProdDepotList
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2697441266
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ["商品", "赠品"][
                                            Number(scope.row.exchangeProdType) -
                                              1
                                          ]
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1692293923
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exchangeProdName",
                            "min-width": "200",
                            "show-overflow-tooltip": "",
                            label: "采购商品",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品图片" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "查看更多",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "60px",
                                            height: "60px",
                                            cursor: "pointer",
                                          },
                                          attrs: {
                                            src:
                                              _vm.ImgHttps +
                                              scope.row.exchangeProdImage.split(
                                                ","
                                              )[0],
                                          },
                                          on: {
                                            click: function ($event) {
                                              ;(_vm.imageSrc =
                                                scope.row.exchangeProdImage),
                                                (_vm.dialogVisible = true)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2313415768
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exchangeProdBrandName",
                            label: "采购品牌",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exchangeProdQuantity",
                            label: "采购数量",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exchangeProdSpecificationName",
                            label: "采购规格",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exchangeProdPrice",
                            label: "采购单价",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exchangeProdAmount",
                            label: "采购金额",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }